<template>
  <div class="meta-container">

    <!-- Header -->
    <header class="header">
      <img class="logo" alt="Logo design by Rosie Steffy" src="../assets/fz_logo_white.jpeg">
    </header>

    <!-- Main text -->
    <div class="container-flavor">
      <h1 class="header-font-left">Balkan Brass</h1>
      <p class="paragraph-font-left">
        Fanfare Zambaleta (roughly meaning crazy street party with brass)
        is an eight piece Balkan Brass band specializing in spirited music
        of the Serbian, Macedonian, Bulgarian, Greek and especially the Romani
        people. Combining a love of the classic brass bands of the past with
        the modern sounds coming out of the Balkans, Fanfare Zambaleta brings
        an irresistible blend of old and new to get you dancing! They've learned
        from some of the greats including Demiran Ćerimović, Džambo Aguševi
        Orkestar and Nizo Alimov (of Kočani Orkestar) and are now embarking on
        a new journey to write original tunes inspired by their deep love of the music.
      </p>
      <h1 class="header-font-right">Musicians</h1>
      <p class="paragraph-font-right">
        The band is directed by <RouterLink class="internal-link" to="/greg">Gregory Masaki Jenkins</RouterLink> (alto sax, clarinet)
        and features <a class="internal-link" href="https://www.instagram.com/joeyjayf/" target="_blank">Joey Friedman</a> (alto sax), Noah Levitt, <a class="internal-link" href="https://www.instagram.com/b0n0s/" target="_blank">Peter Bonos</a>, and <a class="internal-link" href="https://bandcamp.com/maxdanielmusic" target="_blank">Max Miller-Loran</a>
        (trumpets), Rachel MacFarlane, <a class="internal-link" href="https://www.instagram.com/zoraked/?hl=en" target="_blank">Adam Waite</a>, and Brendan Mauro (mid horns), Evan Stuart (sousaphone)
        and Ivan Velev (percussion, vocals).
      </p>
      <h1 class="header-font-left">Bay Area</h1>
      <p class="paragraph-font-left">
        Fanfare Zambaleta regularly performs for public and private events around the greater San Francisco Bay Area, including weddings, parties, celebrations, and dance & cultural events. You can often find them performing at the <a class="internal-link" href="https://eefc.org/teacher/fanfare-zambaleta/" target="_blank">EEFC</a>'s <a class="internal-link" href="https://eefc.org/balkan-camp/west-coast-2/" target="_blank">Mendocino Balkan Camp</a>, <a class="internal-link" href="https://www.instagram.com/balkansundays/" target="_blank">Balkan Sundays</a>, <a class="internal-link" href="https://www.ashkenaz.com/" target="_blank">Ashkenaz in Berkeley</a>, <a class="internal-link" href="https://kolofestival.org/performers.html" target="_blank">California Kolo Festival</a>, <a class="internal-link" href="https://berkeleybalkanbacchanal.wordpress.com/" target="_blank">Berkeley Balkan Bacchanal at the Starry Plough Pub</a>, and more.
      </p>
    </div>

    <!-- Additional Image -->
    <img class="full-width-img" alt="Photo by Saban Redzic" src="../assets/fz-moraga.jpeg">

    <!-- Listen Section -->
    <div class="listen-section">
      <h1 class="header-font-center">Listen</h1>
      <div class="bandcamp-embed">
        <iframe style="border: 0; width: 700px; height: 274px;" src="https://bandcamp.com/EmbeddedPlayer/album=3396076375/size=large/bgcol=000000/linkcol=ffffff/artwork=small/transparent=true/" seamless><a href="https://fanfarezambaleta.bandcamp.com/album/fanfare-zambaleta">Fanfare Zambaleta by Fanfare Zambaleta</a></iframe>
      </div>
    </div>

    <!-- Additional Image -->
    <img class="full-width-img" alt="Photo by Tano Brock" src="../assets/FZangle.jpg">

    <!-- Contact Section -->
    <div class="booking-container">
      <h1 class="header-font-center">Contact</h1>
      <p class="paragraph-font-center">
        For booking, inquiries, and all other questions, please contact
        <br />
        Gregory Masaki Jenkins
        <br />
        <a class="email-link" href="mailto:fanfarezambaleta@gmail.com">fanfarezambaleta@gmail.com</a>
      </p>

      <!-- Social icon links -->
      <div class="icon-link-container">
        <a class="icon-anchor" href="https://www.facebook.com/FanfareZambaleta/" aria-label="FZ Facebook Page">
          <svg class="icon-link" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path fill="currentColor" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
          </svg>
        </a>
        <a class="icon-anchor" href="https://www.youtube.com/user/FanfareZambaleta" aria-label="FZ Youtube Page">
          <svg class="icon-link" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path fill="currentColor" d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
          </svg>
        </a>
        <a class="icon-anchor" href="https://www.instagram.com/fanfarezambaleta/" aria-label="FZ Instagram Page">
          <svg class="icon-link" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path fill="currentColor" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
          </svg>
        </a>
      </div>
    </div>

  </div>
</template>


<script>
import { RouterLink } from 'vue-router';

export default {
  data() {
    return {
      bandcampUrl: "https://bandcamp.com/EmbeddedPlayer/album=3396076375/bgcol=000000/linkcol=FFFFFF/artwork=small/tracklist=true"
    };
  },
  components: { RouterLink },
};
</script>

<style scoped>
.meta-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 870px;
  margin: 0 auto;
  background-color: black;
}
.header {
  background-color: black;
  padding: 22px 0 0;
  display: flex;
  justify-content: center;
}
.logo {
  width: 69.7%;
  height: auto;
  display: block;
}
.full-width-img {
  width: 100%;
  height: auto;
  display: block;
}
h1, h2 {
  letter-spacing: 0.04em;
}
.header-font-center {
  color: white;
  text-align: center;
  margin-top: 0;
  padding-bottom: 10px;
}
.header-font-right {
  color: white;
  text-align: right;
}
.header-font-left {
  color: white;
  text-align: left;
}
p {
  line-height: 1.2;
  margin-bottom: 1.5em;
}
.paragraph-font-center {
  color: rgb(202, 202, 203);
  text-align: center;
  font-size: large;
}
.paragraph-font-right {
  color: rgb(202, 202, 203);
  text-align: right;
  font-size: large;
}
.paragraph-font-left {
  color: rgb(202, 202, 203);
  text-align: left;
  font-size: large;
}
.container-flavor {
  padding: 50px 5%;
  background-color: black;
}
.listen-section {
  padding: 40px 5% 60px;
  background-color: black;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}
.bandcamp-embed {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 10px;
}
.booking-container {
  padding: 40px 8% 60px;
  background-color: black;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.internal-link {
  color: rgb(202, 202, 203);
  text-decoration: none;
  transition: color 0.2s;
}
.internal-link:hover {
  color: rgb(195, 255, 235);
}
.email-link {
  color: rgb(202, 202, 203);
  text-decoration: underline;
  transition: color 0.2s;
}
.email-link:hover {
  color: rgb(195, 255, 235);
}
.icon-link-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 16px;
}
.icon-anchor {
  display: flex;
  color: white;
  transition: color 0.2s;
}
.icon-anchor:hover {
  color: rgb(195, 255, 235);
}
.icon-link {
  width: 24px;
  height: 24px;
  display: block;
}
</style>
